import Raven from 'raven-js';
import {
  toggle,
  removeClass,
} from '../helpers/domHelpers'; // args: element to hide, element to show
import { widgetCtrl as ctrl } from '../widgetController';
import widgetButton from './widgetButton';
import widgetModal from './widgetModal';
import { hideMainButton } from '../helpers/setColors';
import styles from '../css/widgetModal.css';


// Note: ony stops body scrolling on desktop.
// To enable scrolling, uncomment position:fixed on noscroll class in widetmodal.css media query.
// Comes at a cost of not being able to hide url and botttom bar anymore (that's way not doing it)
const toggleScroll = (function () {
  let scrollAmount;
  return function (on) {
    if (on) {
      removeClass(document.body, styles.noscroll);
      window.scrollTo(0, scrollAmount);
    } else {
      scrollAmount = document.body.scrollTop;
      document.body.className += ` ${styles.noscroll}`;
    }
  };
}());


const widget = {
  init(widgetDiv) {
    this.hideMainButton = hideMainButton();
    this.widgetModalElem = widgetModal.init();
    this.widgetButtonElem = widgetButton.init();

    if (this.hideMainButton) {
      widgetDiv.append(this.widgetModalElem);
    } else {
      this.widgetButtonElem.addEventListener('click', this.onOpenModalClick.bind(this));
      widgetDiv.append(this.widgetButtonElem, this.widgetModalElem);
    }

    document.addEventListener('click', this.onCloseModalClick.bind(this));

    if (window.location.hash === '#/schedule-consultation') {
      widgetModal.render();
      toggle(this.widgetButtonElem, this.widgetModalElem);
    }

    document.body.addEventListener('click', this.externalClick.bind(this));
  },

  onOpenModalClick() {
    // report to google analytics
    if (process.env.NODE_ENV === 'production') {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Button',
        eventAction: 'openModal',
      });
    }

    ctrl.refreshBookings()
    .then(() => {
      widgetModal.render();
      // update the bookings array with fresh data
      toggle(this.widgetButtonElem, this.widgetModalElem, 'block');
      // needed to show the map:
      window.dispatchEvent(new Event('resize'));

      // disable scrolling when modal is open:
      toggleScroll(false);
    }).catch((err) => {
      Raven.captureException(err);
    });
  },

  externalClick(event) {
    const classList = Array.from(event.target.classList);
    if (classList.includes('openchair-widget')) {
      this.onOpenModalClick();
    }
  },

  onCloseModalClick(event) {
    if (event.target === this.widgetModalElem || event.target.className === styles.closeBtn) {
      // update indicator values:

      widgetButton.render();
      toggle(this.widgetModalElem, this.widgetButtonElem);

      // enable body scrolling when the modal is closed
      toggleScroll(true);
    }
  },

  handleError(errorText) {
    widgetModal.showError(errorText);
  },

  render() {
    widgetModal.render();
    widgetButton.render();
  },
};

export default widget;



// WEBPACK FOOTER //
// ./src/views/index.js